import React, { useEffect, useState } from "react";
import './../Package/PackageDetails.css';
import { useLocation } from 'react-router-dom';
import Enquiryform from "./Enquiry-Details/Enquiry-form";
import axios from "axios";
import { Backdrop, CircularProgress } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import NewPackageInfoDetails from "./NewPackageInfoDetails";
import NewNavBar from "../../components/NewNavBar/NewNavBar";
import HeaderComponent from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import environment from "../../environment/environment";
import Footer from '../../components/Footer/Footer'
import { generatePackagePdf, generatePackagePdfBlob } from "../../components/PDFDownload/PdfDownload";
import { Link, useNavigate, useParams } from "react-router-dom"
import { Box, Button, Tabs, Tab, Paper, Typography, Grid, Card, CardContent, Divider, FormControl } from "@mui/material";
import SignIn from "../../components/SignInComponent/SignIn";
import TextField from '@mui/material/TextField';
import Modal from "@mui/material/Modal";
import ClearIcon from '@mui/icons-material/Clear';
import PhoneInput from 'react-phone-input-2';
import DatesAndPrices from "./DatesAndPrices";
import CustomSpinner from "../../components/CustomeSpinner/CustomeSpinner";
import companyLogo from '../../assets/images/Ghoomoworld-black-logo-1.png'
import jsPDF from "jspdf";
// const datesAndPricesModalStyle = {
//     position: "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "100%",
//     maxWidth: "1000px",
//     height: "auto",
//     maxHeight: "90vh",
//     bgcolor: "white !important",
//     border: "1px solid #fff",
//     borderRadius: "10px",
//     boxShadow: 30,
//     p: 2,
//     overflowY: "auto",
//     "@media (max-width: 600px)": {
//         width: "90%",
//         maxHeight: "100vh",
//         height: '500px',
//     },
// };


function PackageDetails() {

    const [isBookInfoVisible, setIsBookInfoVisible] = useState(false);

    // Separate state for Know Before You Go 
    const [isExpandedKnowBefore, setIsExpandedKnowBefore] = useState(false);

    // Separate state for Additional Information
    const [showModalAdditionalInfo, setShowModalAdditionalInfo] = useState(false);

    const toggleKnowBeforeCollapse = () => {
        setIsExpandedKnowBefore(!isExpandedKnowBefore);
    };

    const handleAdditionalInfoModalOpen = () => {
        setShowModalAdditionalInfo(true);
    };

    const handleAdditionalInfoModalClose = () => {
        setShowModalAdditionalInfo(false);
    };

    const [open, setOpen] = useState(false);
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    const [coverImage, setCoverImage] = useState('');
    const [subImageOne, setSubImageOne] = useState('');
    const [subImageTwo, setSubImageTwo] = useState('');
    const [subImageThree, setSubImageThree] = useState('');
    const [subImageFour, setSubImageFour] = useState('');
    const [name, setName] = useState('');
    const [whatsAppNo, setWhatsAppNo] = useState('')
    const [whatsAppNoError, setWhatsAppNoError] = useState('')
    const [emailId, setEmailId] = useState('');
    const [nameError, setNameError] = useState('');
    const [emailIdError, setEmailIdError] = useState('');
    const [roomPriceMumbai, setRoomPriceMumbai] = useState('');
    const [roomPriceJoining, setRoomPriceJoining] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState('#all-images');
    const [selectedTrip, setSelectedTrip] = useState(0);
    const [packageItemInfo, setPackageItemInfo] = useState(0);
    const [route, setRoute] = useState('');
    const [uniqueStays, setUniqueStays] = useState([]);
    // Function to toggle details visibility
    const location = useLocation();
    // const { data } = location.state || {};
    // const { id } = useParams();
    const id = new URLSearchParams(location.search).get('id') || location.pathname.split('/:').pop();
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [travelDate, setTravelDate] = useState('');
    const [travelCount, setTravelCount] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [activityImageList, setActivityImageList] = useState([]);
    const [alllImageListData, setAllImageList] = useState([]);
    const [destinationImageList, setDestinationImageList] = useState([]);
    const [propertyImageList, setPropertyImageList] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [isModelSign, setIsModelSign] = useState(false);
    const [userDetails, setUserDetails] = useState(null);
    const [priceTableOpen, setPriceTableOpen] = useState(false);
    // const [dateAndPricesPopup, setDateAndPricesPopup] = useState(false);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        window.scrollTo(0, 0)
        setIsModalOpen(true)
        const timer = setTimeout(() => {
            setIsBookInfoVisible(true);
        }, 2000);
        return () => clearTimeout(timer);
    }, []);

    const processAllImages = () => {
        const finalList = [];
        const destinationImages = [];
        const propertyImages = [];
        const activityImages = [];

        packageItemInfo?.locationDetails?.forEach(location => {
            location?.subImageList?.forEach(imageItem => {
                const imageObj = { imagePath: imageItem.locationImage };
                finalList.push(imageObj);
                if (location.locationType === "Destination") {
                    destinationImages.push(imageObj);
                } else if (location.locationType === "Stays") {
                    propertyImages.push(imageObj);
                } else if (location.locationType === "Activities & Sightseeing") {
                    activityImages.push(imageObj);
                }
            });
        });

        setAllImageList(finalList);
        setDestinationImageList(destinationImages);
        setPropertyImageList(propertyImages);
        setActivityImageList(activityImages);
    };

    React.useEffect(() => {
        if (packageItemInfo?.locationDetails && packageItemInfo?.locationDetails.length > 0) {
            processAllImages();
        }
    }, [packageItemInfo?.locationDetails]);

    const handleTabClick = (event, targetId) => {
        event.preventDefault();
        setActiveTab(targetId);
    };

    const closeCard = () => {
        setIsBookInfoVisible(false);
    };
    const handleOpenPriceTable = () => {
        setPriceTableOpen(true);
    }
    const handleClosePriceTable = () => {
        setPriceTableOpen(false);
    }
    // const handleOpenDatesAndPricesPopup = () => {
    //     setDateAndPricesPopup(true);
    // }
    // const handleCloseDatesAndPricesPopup = () => {
    //     setDateAndPricesPopup(false);
    // }
    const handleCloseEmailModal = () => {
        console.log("hii")
        setOpen(false);
        handleClearForm()
    };
    const handleCloseDownloadModal = () => {
        setDownloadModalOpen(false);
        handleClearForm('');
    }
    const handleOpen = () => {
        setOpen(true);
    }
    const handleOpenDownloadModal = (packageItemInfo) => {
        console.log(packageItemInfo)
    }
    const handleDownloadPdf = async (event) => {
        event.preventDefault();
        let isValid = true;
        if (!name) {
            setNameError('Please provide valid information');
            isValid = false;
        }
        if (!whatsAppNo) {
            setWhatsAppNoError('Please provide valid information');
            isValid = false;
        }
        if (!isValid) return;

        try {
            setIsLoading(true);
            await generatePackagePdf(packageItemInfo, { name, whatsAppNo });
            toast.success('PDF downloaded successfully!');
            handleClearForm();
            
            // Close Bootstrap modal programmatically
            const modalElement = document.getElementById('downloadModal');
            if (modalElement) {
                // Try Bootstrap 5 API first
                if (window.bootstrap && window.bootstrap.Modal) {
                    const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                    if (modalInstance) {
                        modalInstance.hide();
                    } else {
                        // Create new instance and hide it
                        const modal = new window.bootstrap.Modal(modalElement);
                        modal.hide();
                    }
                } else if (window.$ && window.$.fn && window.$.fn.modal) {
                    // Fallback to jQuery if available
                    window.$('#downloadModal').modal('hide');
                } else {
                    // Manual fallback: remove Bootstrap classes and backdrop
                    modalElement.classList.remove('show');
                    modalElement.setAttribute('aria-hidden', 'true');
                    modalElement.style.display = 'none';
                }
                
                // Always clean up backdrop and body classes after a short delay
                // This ensures the backdrop is removed even if Bootstrap's hide() doesn't trigger cleanup
                setTimeout(() => {
                    // Remove all modal backdrops
                    const backdrops = document.querySelectorAll('.modal-backdrop');
                    backdrops.forEach(backdrop => backdrop.remove());
                    
                    // Clean up body classes and styles
                    document.body.classList.remove('modal-open');
                    document.body.style.overflow = '';
                    document.body.style.paddingRight = '';
                    
                    // Ensure modal is hidden
                    if (modalElement) {
                        modalElement.classList.remove('show');
                        modalElement.setAttribute('aria-hidden', 'true');
                        modalElement.style.display = 'none';
                    }
                }, 100);
            }
            
            setDownloadModalOpen(false);
        } catch (err) {
            console.error('PDF generation failed:', err);
            toast.error('Something went wrong. Try again later.');
        } finally {
            setTimeout(() => setIsLoading(false), 800);
        }
    };

    useEffect(() => {
        setIsLoading(true);
        axios({
            // Endpoint to send files
            url: `${environment.config.apiBaseUrl}package/getTourPackage?packageUID=${id}`,
            method: "GET",
            headers: {
                authorization: "your token comes here",
            },
        })
            .then((res) => {
                if (res && res.data) {
                    console.log(res.data[0])
                    setPackageItemInfo(res.data[0])
                    setRoomPriceMumbai(res.data[0].roomDetails[2].roomPrice)
                    setRoomPriceJoining(res.data[0].roomDetails[2].packageCostForJoinLeave)
                    setSubImageOne(res.data[0]?.locationDetails[0]?.subImageList[0]?.locationImage)
                    setSubImageTwo(res.data[0]?.locationDetails[1]?.subImageList[0]?.locationImage)
                    setSubImageThree(res.data[0]?.locationDetails[2]?.subImageList[0]?.locationImage)
                    setSubImageFour(res.data[0]?.locationDetails[2]?.subImageList[1]?.locationImage)
                    // setRoute(res.data[0]?.routeDestination.join('➔ '))
                    // const arrayUnique = Array.from(new Map(res.data[0].itineraryList.map(item => [item.locationName, item])).values());
                    // setUniqueStays(arrayUnique)
                    res.data[0].imageList.map((item) => {
                        setCoverImage(item.coverImage)
                        const subImageListData = item.subImageList.map((subItem) => subItem.subImage);
                        // setSubImageOne(subImageListData[0])
                        // setSubImageTwo(subImageListData[1])
                        // setSubImageThree(subImageListData[2])
                        // setSubImageFour(subImageListData[3])
                        // setRoute(packageItemInfo?.routeDestination.join('➔ ')); 
                    });
                    setTimeout(() => {
                        setIsLoading(false);
                    }, 1500);
                }
            })
            .catch((error) => {
                toast.error("Failed to load package details. Please try again later.");
            })
            .finally(() => {
                toast.error('Something went wrong. Please try again later.')
                setIsLoading(false);
            })

    }, []);

    const handleBookOnline = (event) => {
        console.log(packageItemInfo)
        setIsLoading(true);
        let accessToken = localStorage.getItem("token")
        if (accessToken) {
            setTimeout(() => {
                setIsLoading(false);
                navigate('/booking', { state: { packageData: packageItemInfo } });
            })
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setIsModelSign(true)
            })
        }
    }

    const validateForm = () => {
        const newErrors = {};

        if (!fullName.trim()) newErrors.fullName = 'Full Name is required';

        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            newErrors.email = 'Valid Email is required';
        }

        if (!mobileNo.trim()) {
            newErrors.mobileNo = 'Mobile No. is required';
        }
        if (!travelDate) newErrors.travelDate = 'Travel Date is required';
        if (!travelCount) newErrors.travelCount = 'Traveller Count is required';
        if (!message.trim()) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (field, value) => {
        // Update the field value
        switch (field) {
            case 'fullName':
                setFullName(value);
                break;
            case 'email':
                setEmail(value);
                break;
            case 'mobileNo':
                setMobileNo(value);
                break;
            case 'travelDate':
                setTravelDate(value);
                break;
            case 'travelCount':
                setTravelCount(value);
                break;
            case 'message':
                setMessage(value);
                break;
            default:
                break;
        }

        if (errors[field]) {
            setErrors((prevErrors) => ({ ...prevErrors, [field]: '' }));
        }
    };

    const handleCancel = () => {
        setEmail('')
        setErrors({})
        setFullName('')
        setMessage('')
        setMobileNo('')
        setTravelDate('')
        setTravelCount('')

    }

    const sendEnquiry = () => {
        setIsLoading(true);
        if (!validateForm()) {
            // toast.error('Please Enter Valid Details To Connect With An Experts!')
            return;
        }

        const requestBody = {
            "fullName": fullName,
            "email": email,
            "phoneNumber": mobileNo,
            "travelDate": travelDate,
            "travellerCount": travelCount,
            "message": message,
            "type": "website"
        };
        axios({
            url: `${environment.config.apiBaseUrl}enquiry/createEnquiryDeatils`,
            method: "POST",
            headers: {
                authorization: "your token comes here",
            },
            data: requestBody
        })
            .then((res) => {
                setLoading(false);
                if (res && res.data) {
                    // toast.success('Your Equiry Details Added Successfully Our Team Will Contact You Soon!')
                    document.getElementById("exampleModal").classList.remove("show", "d-block");
                    document.querySelectorAll(".modal-backdrop")
                        .forEach(el => el.classList.remove("modal-backdrop"));
                }
                setTimeout(() => {
                    toast.success('Message sent successfully!')
                    setIsLoading(false);
                }, 1500);
            })
            .catch(() => {
                toast.error('Something went wrong please try again later.')
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            });
        setFullName('');
        setEmail('');
        setMessage('');
        setTravelCount('');
        setTravelDate('');
        setMessage('');
        setMobileNo('')
    };

    const handleClose = (data) => {
        if (!data) {
            setIsModelSign(false);
        }
    };
    const onSignInUser = (data) => {
        setUserDetails(data);
    }
    const handleChangeEmail = (event) => {
        const value = event.target.value
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
            setEmailIdError('Please provid a valid information')
        } else if (!value) {
            setEmailIdError('Please provid a valid information')
        } else {
            setEmailIdError('')
        }
        setEmailId(value)
    }
    const handleChangeName = (event) => {
        const value = event.target.value;
        if (!value) {
            setNameError('Please provid a valid information')
        } else {
            setNameError('')
        }
        setName(value)
    }
    const handleChangeWhatsAppNo = (value) => {
        if (!value) {
            setWhatsAppNoError('Invalid mobile number format');
        } else {
            setWhatsAppNoError('');
        }
        setWhatsAppNo(value);
    };
    const handleSendEmail = async (event) => {
        event.preventDefault();
      
        // Basic validation
        let isValid = true;
        if (!name) {
          setNameError("Please provide valid information");
          isValid = false;
        }
        if (!emailId) {
          setEmailIdError("Please provide valid information");
          isValid = false;
        }
        if (!isValid) return;
      
        setIsLoading(true);
      
        try {
          // -----------------------------------------------------
          // 1) Generate PDF
          // -----------------------------------------------------
          const doc = new jsPDF();
          doc.setFontSize(14);
          doc.text(`${packageItemInfo?.packageName || "Itinerary"} PDF`, 10, 20);
          doc.setFontSize(11);
          doc.text("This PDF is auto-generated.", 10, 30);
          doc.text("Generated for: " + name, 10, 40);
          doc.text("Email: " + emailId, 10, 50);
          doc.text("Generated At: " + new Date().toLocaleString(), 10, 60);
      
          // Convert to Blob
          const pdfBlob = doc.output("blob");
      
          // Convert Blob → File
          const pdfFileName = `${packageItemInfo?.packageName || "Itinerary"}.pdf`;
          const pdfFile = new File([pdfBlob], pdfFileName, { type: "application/pdf" });
      
          // -----------------------------------------------------
          // 2) Prepare FormData
          // -----------------------------------------------------
          const formData = new FormData();
          formData.append("file", pdfFile);
          formData.append("email", emailId);
      
          // -----------------------------------------------------
          // 3) Send to server
          // -----------------------------------------------------
          const response = await axios.post(
            `${environment.config.apiBaseUrl}upload/sendMailWithPdf`,
            formData,
            {
              headers: {
                // ❌ Don't manually set Content-Type for FormData
                // ✔ Authorization only if token required
                // Authorization: `Bearer ${token}`
              }
            }
          );
      
          if (response && response.status === 200) {
            toast.success("The PDF has been sent to your email.");
            handleClearForm();
            
            // Close Bootstrap modal programmatically
            const modalElement = document.getElementById('sentMailModal');
            if (modalElement) {
              // Try Bootstrap 5 API first
              if (window.bootstrap && window.bootstrap.Modal) {
                const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                  modalInstance.hide();
                } else {
                  // Create new instance and hide it
                  const modal = new window.bootstrap.Modal(modalElement);
                  modal.hide();
                }
              } else if (window.$ && window.$.fn && window.$.fn.modal) {
                // Fallback to jQuery if available
                window.$('#sentMailModal').modal('hide');
              } else {
                // Manual fallback: remove Bootstrap classes and backdrop
                modalElement.classList.remove('show');
                modalElement.setAttribute('aria-hidden', 'true');
                modalElement.style.display = 'none';
              }
              
              // Always clean up backdrop and body classes after a short delay
              // This ensures the backdrop is removed even if Bootstrap's hide() doesn't trigger cleanup
              setTimeout(() => {
                // Remove all modal backdrops
                const backdrops = document.querySelectorAll('.modal-backdrop');
                backdrops.forEach(backdrop => backdrop.remove());
                
                // Clean up body classes and styles
                document.body.classList.remove('modal-open');
                document.body.style.overflow = '';
                document.body.style.paddingRight = '';
                
                // Ensure modal is hidden
                if (modalElement) {
                  modalElement.classList.remove('show');
                  modalElement.setAttribute('aria-hidden', 'true');
                  modalElement.style.display = 'none';
                }
              }, 100);
            }
            
            handleCloseEmailModal();
            setOpen(false);
      
            setTimeout(() => setIsLoading(false), 1500);
          }
        } catch (error) {
          console.error("Error sending email:", error);
          toast.error("Something went wrong. Please try again later.");
          setTimeout(() => setIsLoading(false), 1500);
        }
    };
      
    const handleClearForm = () => {
        setName('');
        setNameError('');
        setEmailId('');
        setEmailIdError('');
        setWhatsAppNo('');
        setWhatsAppNoError('');
    }

    return <>
        <div className="stickyheader">
            <HeaderComponent userDetails={userDetails}></HeaderComponent>
            <NewNavBar className='newnavbartoggle' />
        </div>
        <Sidebar className='sidebartoggle' />
        {isLoading &&
            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backdropFilter: "blur(5px)",
                    backgroundColor: "rgba(0, 0, 0, 0.4)"
                }}
                open={isLoading}
            >
                <CustomSpinner color="inherit" />
            </Backdrop>
        }
        <Toaster
            position="top-right"
            reverseOrder={false}
        />

        <div className="main">
            <div className="container grid-custom">
                <div className="row" style={{ '--bs-gutter-x': '0.5rem' }}>
                    <div
                        className="col-sm-6 mt-1 position-relative coverimg-main-div"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasRight"
                        onClick={(e) => handleTabClick(e, '#all-images')}
                        style={{ cursor: 'pointer' }}
                    >
                        <img
                            src={coverImage}
                            style={{ borderRadius: '10px 0 0 10px' }}
                            alt="Main Cover"
                            className="img-fluid mx-auto d-block main-cover-image"
                        />
                    </div>

                    <div className="col-sm-6">
                        <div className="row" style={{ '--bs-gutter-x': '0.5rem' }}>
                            <div
                                className="col-6 mt-1 position-relative destination-div"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight"
                                onClick={(e) => handleTabClick(e, '#destination')}
                                style={{ cursor: 'pointer' }}
                            >
                                <img src={subImageOne} alt="" className="img-fluid sub-image" />
                                <div className="main-image-text">Destination</div>
                            </div>

                            <div
                                className="col-6 mt-1 position-relative stays-div"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight"
                                onClick={(e) => handleTabClick(e, '#property')}
                                style={{ cursor: 'pointer' }}
                            >
                                <img src={subImageTwo} alt="" className="img-fluid sub-image" style={{ borderRadius: '0 10px 0 0' }} />
                                <div className="stays-text">Stays</div>
                            </div>

                            <div
                                className="col-6 mt-1 position-relative activities-div"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight"
                                onClick={(e) => handleTabClick(e, '#activities')}
                                style={{ cursor: 'pointer' }}
                            >
                                <img src={subImageThree} alt="" className="img-fluid sub-image" />
                                <div className="activity-text">Activities & Sightseeing</div>
                            </div>

                            <div
                                className="col-6 mt-1 position-relative activities-div"
                                data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasRight"
                                onClick={(e) => handleTabClick(e, '#all-images')}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src={subImageFour}
                                    style={{ borderRadius: '0 0 10px 0' }}
                                    alt=""
                                    className="img-fluid sub-image"
                                />
                                <div className="image-view-button disabled-button-style">
                                    <i className="bi bi-image me-2"></i>
                                    View All Images
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* ******************************** carouselExampleCaptions ******************************  */}
        <div className="main-carousel-packageDetails">
            <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active"
                        aria-current="true" aria-label="Slide 1"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"
                        aria-label="Slide 2"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"
                        aria-label="Slide 3"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"
                        aria-label="Slide 4"></button>
                    <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="4"
                        aria-label="Slide 5"></button>
                </div>
                <div className="carousel-inner">
                    <div className="carousel-item active">
                        <div className="carousel-image-wrapper">
                            <img src={coverImage} className="d-block w-100 img-fluid img-width-container" alt="..." />
                        </div>
                        <div className="carousel-caption  d-md-block">
                            <h5 className="font-title-bold">{packageItemInfo?.packageName}</h5>
                            <div className="days_and_nights">{packageItemInfo.packageDays}days &amp; {packageItemInfo.packageNight} nights | {packageItemInfo.packageDays}D {packageItemInfo.routeName}</div>
                            <h6 className="starting-at-prices">INR {packageItemInfo?.packageWithDiscountPrices ? packageItemInfo?.packageWithDiscountPrices : 0}<span
                                className="package-price-decoration"> INR
                                {packageItemInfo?.packagePrices ? packageItemInfo?.packagePrices : 0}</span></h6>
                            <button className="btn btn-book-color" onClick={handleBookOnline}>Book
                                Now<div className="dot"></div></button>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carousel-image-wrapper">
                            <img src={subImageOne} className="d-block w-100 img-fluid img-width-container" alt="..." />
                        </div>
                        <div className="carousel-caption  d-md-block">
                            <h5 className="font-title-bold">{packageItemInfo?.packageName}</h5>
                            <div className="days_and_nights">{packageItemInfo.packageDays}days &amp; {packageItemInfo.packageNight} nights | {packageItemInfo.packageDays}D {packageItemInfo.routeName}</div>
                            <h6 className="starting-at-prices">INR {packageItemInfo?.packageWithDiscountPrices ? packageItemInfo?.packageWithDiscountPrices : 0}<span
                                className="package-price-decoration"> INR
                                {packageItemInfo?.packagePrices ? packageItemInfo?.packagePrices : 0}</span></h6>
                            <button className="btn btn-book-color" onClick={handleBookOnline}>Book
                                Now<div className="dot"></div></button>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carousel-image-wrapper">
                            <img src={subImageTwo} className="d-block w-100 img-fluid img-width-container" alt="..." />
                        </div>
                        <div className="carousel-caption  d-md-block">
                            <h5 className="font-title-bold">{packageItemInfo?.packageName}</h5>
                            <div className="days_and_nights">{packageItemInfo.packageDays}days &amp; {packageItemInfo.packageNight} nights | {packageItemInfo.packageDays}D {packageItemInfo.routeName}</div>
                            <h6 className="starting-at-prices">INR {packageItemInfo?.packageWithDiscountPrices ? packageItemInfo?.packageWithDiscountPrices : 0}<span
                                className="package-price-decoration"> INR
                                {packageItemInfo?.packagePrices ? packageItemInfo?.packagePrices : 0}</span></h6>
                            <button className="btn btn-book-color" onClick={handleBookOnline}>Book
                                Now<div className="dot"></div></button>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carousel-image-wrapper">
                            <img src={subImageThree} className="d-block w-100 img-fluid img-width-container" alt="..." />
                        </div>
                        <div className="carousel-caption  d-md-block">
                            <h5 className="font-title-bold">{packageItemInfo?.packageName}</h5>
                            <div className="days_and_nights">{packageItemInfo.packageDays}days &amp; {packageItemInfo.packageNight} nights | {packageItemInfo.packageDays}D {packageItemInfo.routeName}</div>
                            <h6 className="starting-at-prices">INR {packageItemInfo?.packageWithDiscountPrices ? packageItemInfo?.packageWithDiscountPrices : 0}<span
                                className="package-price-decoration"> INR
                                {packageItemInfo?.packagePrices ? packageItemInfo?.packagePrices : 0}</span></h6>
                            <button className="btn btn-book-color" onClick={handleBookOnline}>Book
                                Now<div className="dot"></div></button>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <div className="carousel-image-wrapper">
                            <img src={subImageFour} className="d-block w-100 img-fluid img-width-container" alt="..." />
                        </div>
                        <div className="carousel-caption  d-md-block">
                            <h5 className="font-title-bold">{packageItemInfo?.packageName}</h5>
                            <div className="days_and_nights">{packageItemInfo.packageDays}days &amp; {packageItemInfo.packageNight} nights | {packageItemInfo.packageDays}D {packageItemInfo.routeName}</div>
                            <h6 className="starting-at-prices">INR {packageItemInfo?.packageWithDiscountPrices ? packageItemInfo?.packageWithDiscountPrices : 0}<span
                                className="package-price-decoration"> INR
                                {packageItemInfo?.packagePrices ? packageItemInfo?.packagePrices : 0}</span></h6>
                            <button className="btn btn-book-color" onClick={handleBookOnline}>Book
                                Now<div className="dot"></div></button>
                        </div>
                    </div>
                </div>
                <button
                    className="carousel-control-prev bannerimg-carousel-control-prev-tourpage"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="prev"
                >
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button
                    className="carousel-control-next bannerimg-carousel-control-next-tourpage"
                    type="button"
                    data-bs-target="#carouselExampleCaptions"
                    data-bs-slide="next"
                >
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        {/* ************************Download Modal******************************* */}
        <div className="modal fade" id="downloadModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content modal-content-overflow">
                    <button
                        type="button"
                        className="customer-close-btn"
                        onClick={handleCloseDownloadModal}
                        data-bs-dismiss="modal"
                    >
                        {" "}
                        &times;
                    </button>
                    <div className="modal-body p-0 m-0">
                        <>
                            {isLoading &&
                                <Backdrop
                                    sx={{
                                        color: "#fff",
                                        zIndex: (theme) => theme.zIndex.drawer + 1,
                                        backdropFilter: "blur(5px)",
                                        backgroundColor: "rgba(0, 0, 0, 0.4)"
                                    }}
                                    open={isLoading}
                                >
                                    <CustomSpinner color="inherit" />
                                </Backdrop>
                            }
                            <Grid container spacing={2} className="sent-email-form">
                                <Grid item xs={12} md={6} sx={{ textAlign: 'center', display: { xs: 'none', md: 'block' } }}>
                                    {packageItemInfo?.imageList?.[0]?.coverImage && (
                                        <img
                                            src={packageItemInfo.imageList[0].coverImage}
                                            alt="Package"
                                            style={{ maxWidth: '100%', height: '100%', borderRadius: '4px', objectFit: 'cover' }}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} md={6} >
                                    <Grid container spacing={3} sx={{ padding: { xs: '20px', md: '0px' } }}>
                                        <Grid item xs={12} sx={{ marginBottom: 1, paddingRight: '15px', marginTop: 2 }}>
                                            You're downloading the itinerary & price details for tour
                                        </Grid>
                                        <Grid item xs={12} sx={{ marginBottom: 1, paddingRight: '15px' }}>
                                            <TextField
                                                fullWidth
                                                label="Name"
                                                variant="outlined"
                                                value={name}
                                                onChange={handleChangeName}
                                            />
                                            {nameError && (
                                                <p style={{ color: 'red', fontSize: '10px', margin: '4px 0 0' }}>{nameError}</p>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sx={{ marginBottom: 1, paddingRight: '15px' }}>
                                            <PhoneInput
                                                country={'in'}
                                                value={whatsAppNo}
                                                onChange={handleChangeWhatsAppNo}
                                                inputStyle={{ width: '100%', height: '55px' }}
                                                countryCodeEditable={false}
                                            />
                                            {whatsAppNoError && (
                                                <p style={{ color: 'red', fontSize: '10px', margin: '4px 0 0' }}>{whatsAppNoError}</p>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 10, marginRight: 15 }}>
                                            <Button style={{ color: '#2d2b29' }} onClick={handleClearForm}> Cancel</Button>
                                            <Button style={{ backgroundColor: '#fff099', color: '#2d2b29', marginLeft: 5 }} onClick={handleDownloadPdf}><i class="bi bi-download me-1"></i> Download</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    </div>
                </div>
            </div>
        </div>
        {/* ******************************************sent Mail Modal******************************** */}
        <div className="modal fade" id="sentMailModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content modal-content-overflow">
                    <button
                        type="button"
                        className="customer-close-btn"
                        onClick={handleCloseEmailModal}
                        data-bs-dismiss="modal"
                    >
                        {" "}
                        &times;
                    </button>
                    <div className="modal-body p-0 m-0">
                        <>
                            <Grid container spacing={2} className="sent-email-form">
                                <Grid item xs={12} md={6} sx={{ textAlign: 'center', display: { xs: 'none', md: 'block' } }}>
                                    {packageItemInfo?.imageList?.[0]?.coverImage && (
                                        <img
                                            src={packageItemInfo.imageList[0].coverImage}
                                            alt="Package"
                                            style={{ maxWidth: '100%', height: '100%', borderRadius: '4px', objectFit: 'cover' }}
                                        />
                                    )}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={3} sx={{ padding: { xs: '20px', md: '0px' } }}>
                                        <Grid item xs={12} sx={{ marginBottom: 1, paddingRight: '15px', marginTop: 2 }}>
                                            You're printing the itinerary & price details for tour
                                        </Grid>
                                        <Grid item xs={12} sx={{ marginBottom: 1, paddingRight: '15px' }}>
                                            <TextField
                                                fullWidth
                                                label="Name"
                                                variant="outlined"
                                                value={name}
                                                onChange={handleChangeName}
                                            />
                                            {nameError && (
                                                <p style={{ color: 'red', fontSize: '10px', margin: '4px 0 0' }}>{nameError}</p>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sx={{ paddingRight: '15px' }}>
                                            <TextField
                                                fullWidth
                                                label="Email Id"
                                                variant="outlined"
                                                value={emailId}
                                                onChange={handleChangeEmail}
                                            />
                                            {emailIdError && (
                                                <p style={{ color: 'red', fontSize: '10px', margin: '4px 0 0' }}>{emailIdError}</p>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 10, marginRight: 15 }}>
                                            <Button style={{ color: '#2d2b29' }} onClick={handleClearForm}> Cancel</Button>
                                            <Button style={{ backgroundColor: '#fff099', color: '#2d2b29', marginLeft: 5 }} onClick={handleSendEmail}><i class="bi bi-envelope me-1"></i> Sent Email</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                    </div>
                </div>
            </div>
        </div>
        {/* ***********************Dates and prices Modal ************************************ */}
        <div className="modal fade" id="viewPriceModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content modal-content-overflow">
                    <div className="modal-header">
                        <div className="container modal-heading-section">
                            <div className="row">
                                <div className="d-flex flex-column justify-content-start alig-items-center">
                                    <div style={{ fontSize: '18px', color: '#2d2b29' }}>Detailed tour Price</div>
                                    <div style={{ fontSize: '12px', color: '#2d2b29' }}>Prices & discounts are Per Person for Indian Nationals only.</div>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="customer-close-btn"
                            onClick={handleCancel}
                            data-bs-dismiss="modal"
                        >
                            {" "}
                            &times;
                        </button>

                    </div>
                    <div className="modal-body">
                        <>
                            <div className="table table-responsive mt-3">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Room Type</th>
                                            <th>Basic Price</th>
                                            <th>Joining/Leaving Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {packageItemInfo && packageItemInfo.roomDetails.map((item, index) => (
                                            <tr key={index}>
                                                <td>{item.roomType}</td>
                                                <td>{item.roomPrice}</td>
                                                <td>{item.packageCostForJoinLeave}</td>
                                            </tr>


                                        ))}
                                        <tr>
                                            <td>Child price</td>
                                            <td>{packageItemInfo.childPrice}</td>
                                            <td>{packageItemInfo.childPrice}</td>
                                        </tr>


                                    </tbody>
                                </table>
                            </div>
                            <div>
                                <ul>
                                    <li>Terms and Conditions apply.</li>
                                    <li>5% GST is applicable on given tour price.</li>
                                    <li>Mentioned tour prices are Per Person for Indian Nationals only.</li>
                                </ul>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>
        {/* *********************************Dates& Prices Modal****************************** */}
        <div className="modal fade" id="datesAndPricesModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content modal-content-overflow">
                    <div className="modal-header">
                        <div className="container ">
                            <div className="row">
                                <div className="d-flex flex-row justify-content-between alig-items-center">
                                    <div className="d-flex align-items-center">
                                        <Typography className='d-flex flex-row justify-content-between' id="modal-modal-title" variant="h6">
                                            <div className='d-flex flex-column'>
                                                <strong ><span style={{
                                                    color: "#32325d",
                                                    textDecoration: "underline",
                                                    textDecorationColor: "yellow",
                                                    textDecorationThickness: "2px",
                                                    textUnderlineOffset: '4px',
                                                    marginLeft: '18px'
                                                }}>
                                                    Dates
                                                </span> and prices</strong>
                                            </div>
                                        </Typography>
                                    </div>
                                    <div>
                                        <img src={companyLogo} style={{ height: '50px', width: '90px' }} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            className="customer-close-btn"
                            onClick={handleCancel}
                            data-bs-dismiss="modal"
                        >
                            {" "}
                            &times;
                        </button>

                    </div>
                    <div className="modal-body">
                        <div><DatesAndPrices packageItemInfo={packageItemInfo} /></div>
                    </div>
                </div>
            </div>
        </div>
        {/* *******************************Start Package Info******************************  */}
        <div className="container main-package-mt" >
            <div className="row">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-8 align-self-start mb-2">
                            <div className="Package-title ">
                                <h2 className="package-heading">{packageItemInfo?.packageName}</h2>
                                {/* <a href="booknow.html"> <button id="popup" className="btn btn-book-color"><i
                                    className="bi bi-arrow-right-circle animated-moveLeftToRight-icon"></i> Book
                                    Now</button>
                                </a> */}
                            </div>

                            <div className="itinerary-container">
                                <div className="duration me-2">
                                    {packageItemInfo?.packageDays}D/{packageItemInfo?.packageNight}N
                                </div>

                                <div className="itinerary-details">
                                    {uniqueStays && packageItemInfo?.routeDestination?.map((item) => (

                                        <div className="day">
                                            <span className="day-number me-1">{item.stayDays}</span>
                                            <span className="day-description me-2">Day in<br /><b>{item.destinationName}</b></span>
                                        </div>


                                    ))}
                                </div>
                            </div>
                            {/* <p className="about-us-content py-1"> {packageItemInfo?.description}
                            </p> */}


                        </div>
                        <div className="col-sm-4 align-self-center">
                            <div className="card enquiry-width mt-2">
                                <div className="card-body mt-2">
                                    <div className="col display-package-prices-days" >
                                        <p className="card-text card-prices-pack"><b className="me-1">INR {packageItemInfo?.packageWithDiscountPrices ? new Intl.NumberFormat('en-IN').format(packageItemInfo.packageWithDiscountPrices) : 0}
                                        </b><span
                                            className="package-per-person">Per
                                                Person</span>
                                        </p>
                                        <div className="card-prices-rating">
                                            <span className="package-rating-bi-star-fill"><i className="bi bi-star-fill me-2"></i>
                                                4.8</span>

                                            <span className="package-total-ratings">   (678) </span>

                                        </div>

                                    </div>
                                    <div className="col display-package-prices-days" >
                                        <p className="card-text">
                                            <span className="package-price-decoration-details">
                                                INR {packageItemInfo?.packagePrices ? new Intl.NumberFormat('en-IN').format(packageItemInfo.packagePrices) : 0}

                                            </span>
                                        </p>
                                    </div>
                                    <hr className="mt-margin" />
                                    <div className="col button-display-line d-flex flex-row gap-2">
                                        <button type="button" className="btn btn-color bt-width btn-mobile" data-bs-toggle="modal"
                                            data-bs-target="#exampleModal" style={{ boxShadow: 'none' }}>Send Enquiry</button>
                                        <Button fullWidth type="submit" variant="contained" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '50px', fontWeight: 600, textTransform: 'capitalize', boxShadow: 'none' }} onClick={handleBookOnline}>Book Online</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className=" d-flex flex-row justify-content-end align-items-center mt-2">
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#downloadModal" style={{ color: '#0077b6', boxShadow: 'none' }} onClick={() => handleOpenDownloadModal(packageItemInfo)}>
                                <i class="bi bi-download me-1"></i> Download
                            </button>
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#sentMailModal" style={{ color: '#0077b6', boxShadow: 'none' }}>
                                <i class="bi bi-envelope me-1"></i> Email
                            </button>
                            {/* <Button onClick={handleOpenDownloadModal}><i class="bi bi-download me-1"></i> Download</Button> */}
                            {/* <Button onClick={handleOpen}><i class="bi bi-envelope me-1"></i> Email</Button> */}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-8">
                            <NewPackageInfoDetails data={packageItemInfo}></NewPackageInfoDetails>
                        </div>
                        <div className="col-md-4 ">
                            <div className="card date-prices-modal">
                                <div className="card-body p-0">
                                    <div className="d-flex flex-row justify-content-between align-items-center p-3">
                                        <div className="col-md-6 col-6 d-flex flex-column align-items-start" style={{ lineHeight: '16px' }}>
                                            <div style={{ fontSize: '13px', fontWeight: 500 }}>Mumbai to Mumbai</div>
                                            <div style={{ fontSize: '11px' }}>Starts from</div>
                                            <div style={{ fontSize: '16px', fontWeight: '600' }}>&#8377; {roomPriceMumbai}</div>
                                        </div>
                                        <div className="col-md-6 col-6  d-flex flex-column " style={{ lineHeight: '16px' }}>
                                            <div style={{ fontSize: '13px' }}>
                                                All-inclusive tour from Mumbai to Mumbai
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row justify-content-between mt-3 p-3">
                                        <div className="col-md-6 col-6 d-flex flex-column align-items-start" style={{ lineHeight: '16px' }}>
                                            <div style={{ fontSize: '13px', fontWeight: 500 }}>Joining/Leaving</div>
                                            <div style={{ fontSize: '11px' }}>Starts from</div>
                                            <div style={{ fontSize: '16px', fontWeight: '600' }}>&#8377; {roomPriceJoining}</div>
                                        </div>
                                        <div className="col-md-6 col-6  d-flex flex-column " style={{ lineHeight: '16px' }}>
                                            <div style={{ fontSize: '13px' }}>
                                                Book your own flights & join the tour at the first destination.
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column align-items-center mt-4" style={{ backgroundColor: '#0E1E2C', color: 'white' }}>
                                        <div style={{ fontSize: '10px' }} >Mentioned prices are on a twin-sharing basis.</div>
                                        <div className="mt-2 mb-2" style={{ width: '80%', }}>
                                            {/* <button
                                                className="btn btn-primary "
                                                onClick={handleOpenDatesAndPricesPopup}
                                                style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', borderRadius: '50px', fontWeight: '600',border:'1px solid #fff099',boxShadow:'none' }}
                                            >
                                                Dates & Prices
                                            </button> */}
                                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#datesAndPricesModal" style={{ backgroundColor: '#fff099', color: '#2d2b29', width: '100%', borderRadius: '50px', fontWeight: '600', border: '1px solid #fff099', boxShadow: 'none' }}>
                                                Dates & Prices
                                            </button>
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-end align-items-center p-2" style={{ backgroundColor: '#214869' }}>
                                        <div className="pe-3">
                                            {/* <button className='d-flex justify-content-center align-items-center' style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'white', background: 'transparant', backgroundColor: '#214869' }} onClick={handleOpenPriceTable} >View Pricing Table</button> */}
                                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#viewPriceModal" style={{ fontSize: '14px', margin: '0px', fontWeight: '600px', padding: 0, margin: 0, border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'white', background: 'transparant', backgroundColor: '#214869', boxShadow: 'none' }}>
                                                View Pricing Table
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 sticky-enquiry">
                                <Enquiryform packageItemList={packageItemInfo} style={{ display: 'flex', justifyContent: 'end', alignItems: 'center', position: 'sticky' }}></Enquiryform>
                            </div>
                        </div>
                        <div className=" d-flex flex-row justify-content-end align-items-center mb-4">
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#downloadModal" style={{ color: '#0077b6', boxShadow: 'none' }}>
                                <i class="bi bi-download me-1"></i> Download
                            </button>
                            <button type="button" class="btn" data-bs-toggle="modal" data-bs-target="#sentMailModal" style={{ color: '#0077b6', boxShadow: 'none' }}>
                                <i class="bi bi-envelope me-1"></i> Email
                            </button>
                            {/* <Button onClick={handleOpenDownloadModal}><i class="bi bi-download me-1"></i> Download</Button> */}
                            {/* <Button onClick={handleOpen}><i class="bi bi-envelope me-1"></i> Email</Button> */}
                        </div>

                    </div>
                </div>
            </div>
        </div >

        <Footer />

        {/* <Modal className='gst-modal' open={dateAndPricesPopup} aria-labelledby="modal-modal-title">
            <Box sx={datesAndPricesModalStyle}>
                <div>
                    <img src={companyLogo} style={{ height: '60px', width: '120px' }} />
                </div>
                <Typography className='d-flex flex-row justify-content-between' id="modal-modal-title" variant="h6">
                    <div className='d-flex flex-column'>
                        <strong ><span style={{
                            color: "#32325d",
                            textDecoration: "underline",
                            textDecorationColor: "yellow",
                            textDecorationThickness: "2px",
                            textUnderlineOffset: '4px',
                            marginLeft: '18px'
                        }}>
                            Dates
                        </span> and prices</strong>
                    </div>

                    <Button sx={{ minWidth: 'unset', position: 'absolute', top: 0, right: 0 }} variant="text" color="inherit" onClick={handleCloseDatesAndPricesPopup}>
                        <ClearIcon />
                    </Button>
                </Typography>

                <div><DatesAndPrices packageItemInfo={packageItemInfo} /></div>


            </Box>
        </Modal> */}

        <div className="container display-call-buttom">
            <div className="row">
                <div className="call-buton"><a className="cc-calto-action-ripple" href="tel:9999999"><i className="fa fa-phone"></i>
                </a>
                </div>
            </div>
        </div>

        {/* ************************************offcanvas Start********************************************* */}

        <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
            <div className="offcanvas-header">
                {/* <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button> */}
            </div>
            <div className="offcanvas-body">
                <div className="container">
                    <div className="back-button " data-bs-dismiss="offcanvas" aria-label="Close" style={{ cursor: 'pointer' }}>
                        <i className="bi bi-arrow-left"></i> Back
                    </div>
                    <ul className="nav nav-tabs text-center">
                        <li className="nav-item me-3">
                            <a
                                className={`nav-link ${activeTab === '#all-images' ? 'active' : ''}`}
                                href="#"
                                onClick={(e) => handleTabClick(e, '#all-images')}
                            >
                                All Images ({alllImageListData.length})
                            </a>
                        </li>
                        <li className="nav-item me-3">
                            <a
                                className={`nav-link ${activeTab === '#destination' ? 'active' : ''}`}
                                href="#"
                                onClick={(e) => handleTabClick(e, '#destination')}
                            >
                                Destination ({destinationImageList.length})
                            </a>
                        </li>
                        <li className="nav-item me-3">
                            <a
                                className={`nav-link ${activeTab === '#property' ? 'active' : ''}`}
                                href="#"
                                onClick={(e) => handleTabClick(e, '#property')}
                            >
                                Stays ({propertyImageList.length})
                            </a>
                        </li>
                        <li className="nav-item me-3">
                            <a
                                className={`nav-link ${activeTab === '#activities' ? 'active' : ''}`}
                                href="#"
                                onClick={(e) => handleTabClick(e, '#activities')}
                            >
                                Activities & Sightseeing ({activityImageList.length})
                            </a>
                        </li>
                    </ul>
                    <div id="all-images" className={`image-grid ${activeTab === '#all-images' ? 'active-content' : ''}`}>
                        <div className="container mt-2">
                            <div className="row">
                                {alllImageListData && alllImageListData.map((ele, index) => (
                                    <div key={index} className="col-md-4 mb-3 mt-3">
                                        <img className="img-thumbnail" src={ele.imagePath} style={{ height: "275px" }} alt={`Image ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div id="destination" className={`image-grid ${activeTab === '#destination' ? 'active-content' : ''}`}>
                        <div className="container mt-2">
                            <div className="row">
                                {destinationImageList && destinationImageList.map((ele, index) => (
                                    <div key={index} className="col-md-4 mb-3 mt-3">
                                        <img className="img-thumbnail" src={ele.imagePath} style={{ height: "275px" }} alt={`Destination ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div id="activities" className={`image-grid ${activeTab === '#activities' ? 'active-content' : ''}`}>
                        <div className="container mt-2">
                            <div className="row">
                                {activityImageList && activityImageList.map((ele, index) => (
                                    <div key={index} className="col-md-4 mb-3 mt-3">
                                        <img className="img-thumbnail" src={ele.imagePath} style={{ height: "275px" }} alt={`Activity ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div id="property" className={`image-grid ${activeTab === '#property' ? 'active-content' : ''}`}>
                        <div className="container mt-2">
                            <div className="row">
                                {propertyImageList && propertyImageList.map((ele, index) => (
                                    <div key={index} className="col-md-4 mb-3 mt-3">
                                        <img className="img-thumbnail" src={ele.imagePath} style={{ height: "275px" }} alt={`Property ${index + 1}`} />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* ******************************Send Enquiry Modal************************************* */}
        {
            isModalOpen && (
                <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable modal-down">
                        <div className="modal-content modal-content-overflow">
                            <div className="modal-header">
                                <div className="container modal-heading-section">
                                    <div className="row">
                                        <div className="col-3">
                                            <img src={packageItemInfo && packageItemInfo?.imageList[0]?.coverImage} alt="" className="rounded mx-auto d-block " width="50"
                                                height="50" />
                                        </div>
                                        <div className="col-9">
                                            <h5 className="card-text bold" style={{ fontSize: '12px' }}>{packageItemInfo?.packageName}</h5>
                                            <p className="card-text">
                                                <b className="me-2 package-title-prices">INR {packageItemInfo?.packageWithDiscountPrices ? new Intl.NumberFormat('en-IN').format(packageItemInfo.packageWithDiscountPrices) : 0}
                                                </b>
                                                <span className="package-price-decoration me-1">INR
                                                    {packageItemInfo?.packagePrices ? new Intl.NumberFormat('en-IN').format(packageItemInfo.packagePrices) : 0}</span>
                                                <span className="title-prices">
                                                    SAVE INR  {packageItemInfo?.savePrices ? new Intl.NumberFormat('en-IN').format(packageItemInfo.savePrices) : 0}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <button
                                    type="button"
                                    className="customer-close-btn"
                                    onClick={handleCancel}
                                    data-bs-dismiss="modal"
                                >
                                    {" "}
                                    &times;
                                </button>

                            </div>

                            <div className="modal-body">
                                <>
                                    <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={loading}>
                                        <CircularProgress color="inherit" />
                                    </Backdrop>
                                    <form className="form-modal-wraaper mt-1">
                                        <div className="form-floating mb-3">
                                            <input
                                                type="text"
                                                className={`form-control ${errors.fullName ? 'is-invalid' : ''}`}
                                                placeholder="Full Name"
                                                value={fullName}
                                                onChange={(e) => handleChange('fullName', e.target.value)}
                                            />
                                            <label>Full Name *</label>
                                            {errors.fullName && <div className="invalid-feedback">{errors.fullName}</div>}
                                        </div>
                                        <div className="form-floating mb-3">
                                            <input
                                                type="email"
                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                placeholder="name@example.com"
                                                value={email}
                                                onChange={(e) => handleChange('email', e.target.value)}
                                            />
                                            <label>Email* </label>
                                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                        </div>
                                        <div className="form-floating mb-3">
                                            <PhoneInput
                                                country={'in'}
                                                value={mobileNo}
                                                onChange={(value) => handleChange('mobileNo', value)}
                                                inputStyle={{ width: '100%', height: '55px' }}
                                                countryCodeEditable={false}
                                            />
                                            {errors.mobileNo && (
                                                <div className="invalid-feedback" style={{ display: 'block' }}>
                                                    {errors.mobileNo}
                                                </div>
                                            )}                                           </div>

                                        <div className="row align-self-center">
                                            <div className="col-md-6 mt-1">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="date"
                                                        className={`form-control ${errors.travelDate ? 'is-invalid' : ''}`}
                                                        placeholder="Travel Date"
                                                        value={travelDate}
                                                        min={new Date().toISOString().split('T')[0]}  // Setting min date to today
                                                        max={new Date(new Date().getFullYear() + 1, 11, 31).toISOString().split('T')[0]} // Setting max to last day of next year
                                                        onChange={(e) => handleChange('travelDate', e.target.value)}
                                                    />
                                                    <label>Travel Date*</label>
                                                    {errors.travelDate && <div className="invalid-feedback">{errors.travelDate}</div>}
                                                </div>
                                            </div>


                                            <div className="col-md-6 mt-1">
                                                <div className="form-floating mb-3">
                                                    <input
                                                        type="number"
                                                        className={`form-control ${errors.travelCount ? 'is-invalid' : ''}`}
                                                        placeholder="Traveller Count"
                                                        value={travelCount}
                                                        onChange={(e) => handleChange('travelCount', e.target.value)}
                                                        min={1}
                                                        max={5}
                                                    />
                                                    <label>Traveller Count*</label>
                                                    {errors.travelCount && <div className="invalid-feedback">{errors.travelCount}</div>}
                                                </div>
                                            </div>
                                            <div className="form-floating mb-3">

                                                <textarea
                                                    className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                                                    placeholder="Message"
                                                    value={message}
                                                    rows={4}
                                                    onChange={(e) => handleChange('message', e.target.value)}
                                                    style={{ minHeight: '100px' }}
                                                />
                                                <label className="message-placeholder">Your Requirements *</label>
                                                {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                                            </div>
                                        </div>
                                    </form>
                                </>
                            </div>
                            <hr className="mt-margin" />
                            <div className="modal-footer">
                                <button type="button" className="btn btn-color bt-width" style={{ backgroundColor: '#fff099', border: 'none' }} onClick={sendEnquiry}>Connect with an Expert</button>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        {
            isModelSign && (
                <div>
                    <SignIn isModelSign={isModelSign} closePopup={handleClose} userDetais={onSignInUser}

                        isBookOnline={true} packageItemInfo={packageItemInfo}></SignIn>

                </div>
            )
        }
    </>
}

export default PackageDetails;